import { useRef } from 'react'
import { RatingsGridBars } from './RatingsGridBars'
import { useInView } from 'framer-motion'

export const RatingsGridBarsMotion = () => {
  const ref = useRef(null)
  const inView = useInView(ref, { once: true, amount: 1 })

  return <RatingsGridBars ref={ref} show={inView} />
}
